export const reduceItemWith = (idKey='uuid') => (state, action, reducer) => state?.map(
  (item) => item?.uuid === _.get(action, idKey, 'not_found') ? reducer(item, action) : item
) ?? null;
